import { Button as HpButton } from 'components/shared/button';
import { getConfig } from 'config/configuration';
import { FullPolicyData } from 'interfaces/customerDataTypes';
import { PATH } from 'interfaces/pathTypes';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { QUESTION_SET } from 'actions/getValidConvertibleInstanceAction';
import { renewPolicyAction } from 'actions/renewPolicyAction';
import { InfoBox } from 'components/shared/infoBox';
import { redirectToPolicyPortalAction } from 'actions/redirectToPolicyPortalAction';

import './monthlyPayment.scss';
import { useGetScreenSize } from 'utils';
import { useHistory } from 'react-router-dom';

interface MonthlyPaymentProps {
  selectedPolicy: FullPolicyData;
  policyDetailsId: string;
  historyId: number;
}

const { assetsUrl } = getConfig();

export const MonthlyPayment = ({ selectedPolicy, policyDetailsId, historyId }: MonthlyPaymentProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const username = useAppSelector((state) => state.authentication.email);
  const isAgent = useAppSelector((state) => state.authentication.isAgent);
  const { title, forename, surname, accountNumber, policyNumber, email, correspondencePostcode } = selectedPolicy;
  const { isMobile } = useGetScreenSize();

  const handleConfirmPayment = () => {
    dispatch(renewPolicyAction({ username, isAgent, paymentPreference: 'monthly', policyDetailsId, historyId }));
  };

  const handleBack = () => {
    dispatch(
      redirectToPolicyPortalAction({
        policyDetailsId,
        historyId,
        policyNumber,
        questionSet: QUESTION_SET.RENEWAL_JOURNEY,
        userName: username,
        isAgent,
        context: 'quote',
        emailAddress: email,
        postcode: correspondencePostcode,
        onError: () => history.push(`${PATH.RENEWAL}/error`)
      })
    );
  };

  const mainText = `${title} ${forename} ${surname}`.trim();
  const subText = accountNumber ? `Account ending in ${accountNumber.slice(-4)}` : null;

  return (
    <div className="account-details">
      <div className="account-details-header-container">
        <h2 className="account-details-header">PAYMENT INFORMATION</h2>
        <img
          src={assetsUrl + 'website/directdebitls.png'}
          alt="Direct Debit Logo"
          height={isMobile ? 24 : 32}
          width={isMobile ? 74 : 99}
        />
      </div>
      <InfoBox mainText={mainText} subText={subText} className="account-details-info-box" />
      <HpButton text="Confirm" handleClick={handleConfirmPayment} fullWidth />
      <HpButton text="Back" variant="reversed" id="back-button" fullWidth handleClick={handleBack} />
    </div>
  );
};
